// Guest diagnostic → account hand-off (web adapter).
//
// The onboarding diagnostic is taken as a guest and stashed in localStorage
// (onboarding_test_result + onboarding_test_selected_exam). After sign-up OR
// sign-in, prepareBundle asks resolvePendingDiagnostic() whether to apply it:
// the decision is the shared core rule (@learnzapp/core/readiness
// resolveDiagnosticHandoff), identical to mobile. This file only supplies the
// web inputs: the stash, and the shared-device flow signal — a sessionStorage
// marker set when the diagnostic finishes, so only a sign-in in that same tab
// session counts as "the person who took it".
import { resolveDiagnosticHandoff } from "@learnzapp/core/readiness";
import { APP_BUNDLES } from "../../app_constant";

const RESULT_KEY = "onboarding_test_result";
const EXAM_KEY = "onboarding_test_selected_exam";
const FLOW_MARKER_KEY = "lz_diagnostic_flow";

export function markDiagnosticFlow() {
  try {
    sessionStorage.setItem(FLOW_MARKER_KEY, "1");
  } catch (e) {
    // Storage blocked: the hand-off then discards the result (no flow signal).
  }
}

function readStash() {
  try {
    const result = JSON.parse(localStorage.getItem(RESULT_KEY));
    const exam = JSON.parse(localStorage.getItem(EXAM_KEY));
    if (!result || !exam) return null;
    return { examKey: exam?.key, createdAt: result?.timestamp };
  } catch (e) {
    return null;
  }
}

function hasFlowMarker() {
  try {
    return sessionStorage.getItem(FLOW_MARKER_KEY) === "1";
  } catch (e) {
    return false;
  }
}

/** The shared decision for the current stash: { apply, examKey, reason }. */
export function resolvePendingDiagnostic() {
  return resolveDiagnosticHandoff({
    stash: readStash(),
    now: Date.now(),
    cameFromDiagnosticFlow: hasFlowMarker(),
    validExamKeys: (APP_BUNDLES ?? []).map((b) => b.key),
  });
}

export function clearPendingDiagnostic() {
  try {
    localStorage.removeItem(RESULT_KEY);
    localStorage.removeItem(EXAM_KEY);
    sessionStorage.removeItem(FLOW_MARKER_KEY);
  } catch (e) {
    // Nothing else to do; SAVE_DIAGNOSTIC_RESULTS still guards the exam.
  }
}
